import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";

export function AthletesStatistics() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(true);

    useEffect(() => {
        
    }, []);
    
    return (
        <div className="athletes-ranking-container"> 
            <div className="inner">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && 
                <h1>{ t("Athletes statistics") }</h1>
            }
            </div>
        </div>
    );
}